import {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogContent, IconButton, Typography} from "@mui/material";
import BackspaceRoundedIcon from "@mui/icons-material/BackspaceRounded";
import TableRestaurantRoundedIcon from "@mui/icons-material/TableRestaurantRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {useKioskLang} from "../context/KioskSessionContext";

const MAX_LEN = 3;

//內用選擇後的桌號輸入：大按鍵數字盤，避免叫出 iPad 系統鍵盤
export default function TableNumberDialog({open, onClose, onConfirm}) {
  const {tr} = useKioskLang();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (open) setValue("");
  }, [open]);

  const press = (digit) => setValue((prev) => (prev + digit).slice(0, MAX_LEN));
  const erase = () => setValue((prev) => prev.slice(0, -1));
  const confirm = () => {
    //去掉前導 0（04 → 4），全 0 視為未輸入
    const normalized = value.replace(/^0+(?=\d)/, "");
    if (!normalized || /^0+$/.test(normalized)) return;
    onConfirm(normalized);
  };
  const canConfirm = Boolean(value) && !/^0+$/.test(value);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{p: 3.5, pt: 3}}>
        <Box sx={{display: "flex", alignItems: "center", gap: 1.25}}>
          <TableRestaurantRoundedIcon color="primary" sx={{fontSize: 32}}/>
          <Box sx={{flex: 1}}>
            <Typography sx={{fontSize: 25, fontWeight: 950}}>{tr("enterTableTitle")}</Typography>
            <Typography color="text.secondary" sx={{fontSize: 15.5}}>{tr("enterTableHint")}</Typography>
          </Box>
          <IconButton aria-label={tr("cancel")} onClick={onClose}><CloseRoundedIcon/></IconButton>
        </Box>
        <Box sx={{mt: 2, minHeight: 84, borderRadius: 1.5, bgcolor: "#F7F1E8", border: "2px solid rgba(80,55,40,.15)", display: "flex", alignItems: "center", justifyContent: "center", gap: 1}}>
          <Typography sx={{fontSize: 46, fontWeight: 950, letterSpacing: ".12em", color: value ? "text.primary" : "#B39D8D"}}>
            {value || "—"}
          </Typography>
          {value && <Typography sx={{fontSize: 22, fontWeight: 900, color: "text.secondary"}}>{tr("tableNumber")}</Typography>}
        </Box>
        <Box sx={{mt: 2, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.25}}>
          {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((digit) => (
            <Button key={digit} onClick={() => press(digit)} sx={{minHeight: 74, fontSize: 30, fontWeight: 900, bgcolor: "#FFF", color: "text.primary", border: "1px solid rgba(80,55,40,.15)", "&:hover": {bgcolor: "#FFF8F0"}}}>{digit}</Button>
          ))}
          <Button onClick={erase} aria-label={tr("keypadDelete")} disabled={!value} sx={{minHeight: 74, color: "text.secondary", border: "1px solid rgba(80,55,40,.15)"}}><BackspaceRoundedIcon sx={{fontSize: 30}}/></Button>
          <Button onClick={() => press("0")} sx={{minHeight: 74, fontSize: 30, fontWeight: 900, bgcolor: "#FFF", color: "text.primary", border: "1px solid rgba(80,55,40,.15)", "&:hover": {bgcolor: "#FFF8F0"}}}>0</Button>
          <Button variant="contained" onClick={confirm} disabled={!canConfirm} sx={{minHeight: 74, fontSize: 22, fontWeight: 950}}>{tr("confirm")}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
